/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateAirtableWebhookDto { 
    type: string;
    active?: boolean;
    dataTypes: Array<CreateAirtableWebhookDto.DataTypesEnum>;
    fromSources?: Array<string>;
    changeTypes: Array<CreateAirtableWebhookDto.ChangeTypesEnum>;
    recordChangeScope: string;
    notificationUrl: string;
}
export namespace CreateAirtableWebhookDto {
    export type DataTypesEnum = 'tableData' | 'tableFields' | 'tableMetadata';
    export const DataTypesEnum = {
        TableData: 'tableData' as DataTypesEnum,
        TableFields: 'tableFields' as DataTypesEnum,
        TableMetadata: 'tableMetadata' as DataTypesEnum
    };
    export type ChangeTypesEnum = 'add' | 'remove' | 'update';
    export const ChangeTypesEnum = {
        Add: 'add' as ChangeTypesEnum,
        Remove: 'remove' as ChangeTypesEnum,
        Update: 'update' as ChangeTypesEnum
    };
}


